<template>
	<div>
		<div class="btns-top">
			<a href="#" class="btn btn-add  fa fa-plus transition-fadeinup transition-delay-01"></a>
		</div>

		<table cellpadding="0" cellspacing="0" class="data  transition-fadeinup">
			<thead>
			<tr>
				<th></th>
				<th>Object</th>
				<th>Name (refrence)</th>
				<th>Usage</th>
				<th>Permissions</th>
				<th>Enabled</th>
				<th></th>
				<th></th>
			</tr>
			</thead>

			<tbody>

				<tr>
					<td></td>
					<td>
						Segments, Systems
					</td>
					<td>
						in_the_picture
					</td>
					<td>
						<div class="dropdown">
							<label>templates</label>
							<div class="popup">
								<ul class="options">
									<li>home.php</li>
									<li>news-overview.php</li>
								</ul>
							</div>
						</div>
					</td>
					<td>
						<div class="dropdown">
							<label>Role</label>
							<div class="popup">
								<ul class="options">
									<li><label class="flex-label"><input type="checkbox" name="test" checked>Unautenticated</label></li>
									<li><label class="flex-label"><input type="checkbox" name="test" checked>Autenticated</label></li>
									<li><label class="flex-label"><input type="checkbox" name="test" checked>Client</label></li>
								</ul>
							</div>
						</div>
					</td>
					<td>
						<a href="#" class="btn-switch active"></a>
					</td>
					<td class="btns">
						<a href="pages/settings-views-sidebar.php" data-routing-target="#sidebar" data-marker><i class="fa fa-code"></i></a>
						<a href="#" class="btn-delete-confirm fa fa-trash-alt"></a>
					</td>
					<td></td>
				</tr>

				<tr>
					<td></td>
					<td>
						Segments, Systems
					</td>
					<td>
						in_the_picture
					</td>
					<td>
						<div class="dropdown">
							<label>templates</label>
							<div class="popup">
								<ul class="options">
									<li>home.php</li>
									<li>news-overview.php</li>
								</ul>
							</div>
						</div>
					</td>
					<td>
						<div class="dropdown">
							<label>Role</label>
							<div class="popup">
								<ul class="options">
									<li><label class="flex-label"><input type="checkbox" name="test" checked>Unautenticated</label></li>
									<li><label class="flex-label"><input type="checkbox" name="test" checked>Autenticated</label></li>
									<li><label class="flex-label"><input type="checkbox" name="test" checked>Client</label></li>
								</ul>
							</div>
						</div>
					</td>
					<td>
						<a href="#" class="btn-switch active"></a>
					</td>
					<td class="btns">
						<a href="pages/settings-views-sidebar.php" data-routing-target="#sidebar" data-marker><i class="fa fa-code"></i></a>
						<a href="#" class="btn-delete-confirm fa fa-trash-alt"></a>
					</td>
					<td></td>
				</tr>

				<tr>
					<td></td>
					<td>
						Segments, Systems
					</td>
					<td>
						in_the_picture
					</td>
					<td>
						<div class="dropdown">
							<label>templates</label>
							<div class="popup">
								<ul class="options">
									<li>home.php</li>
									<li>news-overview.php</li>
								</ul>
							</div>
						</div>
					</td>
					<td>
						<div class="dropdown">
							<label>Role</label>
							<div class="popup">
								<ul class="options">
									<li><label class="flex-label"><input type="checkbox" name="test" checked>Unautenticated</label></li>
									<li><label class="flex-label"><input type="checkbox" name="test" checked>Autenticated</label></li>
									<li><label class="flex-label"><input type="checkbox" name="test" checked>Client</label></li>
								</ul>
							</div>
						</div>
					</td>
					<td>
						<a href="#" class="btn-switch active"></a>
					</td>
					<td class="btns">
						<a href="pages/settings-views-sidebar.php" data-routing-target="#sidebar" data-marker><i class="fa fa-code"></i></a>
						<a href="#" class="btn-delete-confirm fa fa-trash-alt"></a>
					</td>
					<td></td>
				</tr>

			</tbody>
		</table>

		<div class="row">
			<div class="col-20  transition-fadeinup transition-delay-01">

				<p>&nbsp;</p>
				<p>&nbsp;</p>

				<div class="msgBox info">
					<p>- Voor elk adresseble object wordt automatisch een view "objectname-page" gegenereerd.</p>
					<p>- Edit & Add-btn outputten in een collection of adressable object.</p>
				</div>

			</div>
		</div>
	</div>
</template>

<script>

export default {
	name: 'views'
}

</script>
